<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- لوحة التحكم -->
    <div class="card shadow-sm mb-4 no-print border-top-danger">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 text-danger fw-bold">
          <i class="fas fa-user-injured ms-2"></i> تقارير الدمج 
        </h5>
      </div>
      <div class="card-body d-flex justify-content-between align-items-center">
        <div>
            <p class="mb-0 text-muted">يحتوي هذا التقرير على حصر شامل لطلاب الدمج وأنواع الإعاقات بكل لجنة.</p>
        </div>
        <button @click="fetchData" class="btn btn-danger fw-bold px-4 ms-2" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            تجهيز التقرير
        </button>
        <button @click="printPage" class="btn btn-dark px-4" :disabled="!reportData.length">
            <i class="fas fa-print ms-2"></i> طباعة
        </button>
      </div>
    </div>

    <!-- منطقة الطباعة -->
    <div id="printMe" v-if="reportData.length > 0">
      
      <!-- حلقة تكرار لكل لجنة (صفحة جديدة لكل لجنة) -->
      <div 
        v-for="(committee, index) in reportData" 
        :key="index" 
        class="committee-section"
        style="page-break-after: always;"
      >
        
        <!-- الترويسة -->
        <div class="header-section text-center mb-4 border-bottom pb-2">
           <h4 class="fw-bold">بيان طلاب الدمج التعليمي   </h4>
           <div class="d-flex justify-content-center gap-3 mt-2">
               <span class="badge bg-light text-dark border border-dark fs-6">لجنة: {{ committee.committee_name }}</span>
               <span class="badge bg-dark text-white fs-6">رقم اللجنة: {{ committee.committee_id }}</span>
           </div>
        </div>

        <!-- 1. جدول الإحصائيات (هام جداً للمطبعة) -->
        <div class="stats-box mb-4 p-3 border border-2 border-dark rounded bg-light-gray">
            <h6 class="fw-bold text-decoration-underline mb-3">أولاً: ملخص احتياجات اللجنة (أنواع الإعاقة):</h6>
            <div class="row g-2">
                <div class="col-4" v-for="(count, type) in committee.stats_by_type" :key="type">
                    <div class="d-flex justify-content-between border bg-white px-2 py-1">
                        <span class="fw-bold small">{{ type }}</span>
                        <span class="badge bg-danger">{{ count }}</span>
                    </div>
                </div>
            </div>
            <div class="mt-3 border-top border-dark pt-2 text-center">
                <h5 class="fw-bold m-0">الإجمالي العام للجنة: ( {{ committee.total_damg }} ) طالب</h5>
            </div>
        </div>

        <!-- 2. كشف الأسماء التفصيلي -->
        <h6 class="fw-bold mb-2">ثانياً: كشف أسماء الطلاب:</h6>
        <table class="table table-bordered border-dark text-center align-middle">
            <thead class="table-dark">
                <tr>
                    <th width="5%">م</th>
                    <th width="10%">رقم الجلوس</th>
                    <th width="30%">اسم الطالب</th>
                    <th width="25%">اسم المدرسة</th>
                    <th width="40%">نوع الإعاقة / الملاحظات</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(student, sIndex) in committee.students" :key="student.id">
                    <td>{{ sIndex + 1 }}</td>
                    <td class="fw-bold fs-5">{{ student.Seating_No }}</td>
                    <td class="text-start fw-bold pe-3">{{ student.Arabic_Name }}</td>
                    <td class="text-start fw-bold pe-3">{{ student.School_Name | truncate(30)}}</td>
                    <td class="fw-bold text-danger bg-light">{{ student.disability_type }}</td>
                </tr>
            </tbody>
        </table>

        <!-- تذييل -->
        <div class="mt-5 d-flex justify-content-between px-5 fw-bold break-avoid">
            <!-- <div>المسئول الإداري</div>
            <div>رئيس المطبعة السرية</div> -->
        </div>

        <!-- فاصل صفحات -->
        <div class="page-break"></div>

      </div>
    </div>
    
    <!-- رسالة فارغة -->
    <div v-else-if="searched" class="alert alert-info text-center mt-5 no-print">
        لا يوجد طلاب دمج مسجلين.
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "IntegrationSecretReport",
  data() {
    return {
      loading: false,
      searched: false,
      reportData: []
    };
  },
   filters: {
    truncate(value, limit) {
      if (!value) return '';
      if (value.length <= limit) return value;
      return value.substring(0, limit) + '..';
    }
  },
  methods: {
    
    async fetchData() {
      this.loading = true;
      this.searched = true;
      try {
        // استبدل بالرابط الحقيقي
        const res = await api.get('/admin/secret-print/integration-report');
        this.reportData = res.data;

        // --- محاكاة البيانات ---
        // setTimeout(() => {
        //     this.reportData = [
        //         {
        //             committee_name: "مدرسة الشهيد أحمد عبد العزيز",
        //             committee_number: "50",
        //             total_damg: 5,
        //             stats_by_type: {
        //                 "إعاقة بصرية (كفيف)": 1,
        //                 "إعاقة ذهنية بسيطة": 3,
        //                 "شلل دماغي": 1
        //             },
        //             students: [
        //                 { id: 1, seating_no: 1005, name: "خالد إبراهيم السيد", disability_type: "إعاقة بصرية (كفيف)" },
        //                 { id: 2, seating_no: 1012, name: "محمد علي حسن", disability_type: "إعاقة ذهنية بسيطة" },
        //                 { id: 3, seating_no: 1020, name: "سعيد محمود", disability_type: "إعاقة ذهنية بسيطة" },
        //                 { id: 4, seating_no: 1025, name: "علي مصطفى", disability_type: "شلل دماغي" },
        //                 { id: 5, seating_no: 1030, name: "ياسر كمال", disability_type: "إعاقة ذهنية بسيطة" },
        //             ]
        //         },
        //         {
        //             committee_name: "مدرسة العريش الإعدادية بنات",
        //             committee_number: "51",
        //             total_damg: 2,
        //             stats_by_type: {
        //                 "ضعف سمع": 2
        //             },
        //             students: [
        //                 { id: 6, seating_no: 2001, name: "منى أحمد", disability_type: "ضعف سمع" },
        //                 { id: 7, seating_no: 2005, name: "سارة محمد", disability_type: "ضعف سمع" },
        //             ]
        //         }
        //     ];
            this.loading = false;
        // }, 800);
        // ---------------------

      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },

    printPage() {
        this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.border-top-danger { border-top: 4px solid #dc3545; }
.bg-light-gray { background-color: #f2f2f2; }

/* === تنسيقات الطباعة === */
@media print {
  @page {
    size: A4 portrait;
    margin: 15mm;
  }
  
  body * { visibility: hidden; }
  .no-print { display: none !important; }
  #printMe, #printMe * { visibility: visible; }
  #printMe { position: absolute; left: 0; top: 0; width: 100%; }

  .committee-section { page-break-after: always; }
  .break-avoid { page-break-inside: avoid; }

  .table-bordered th, .table-bordered td {
      border: 2px solid #000 !important; /* حدود سميكة للوضوح */
      padding: 8px !important;
      font-size: 12pt;
  }

  /* إظهار مربع الإحصائيات بوضوح */
  .stats-box {
      border: 2px solid #000 !important;
      background-color: #eee !important;
      -webkit-print-color-adjust: exact;
  }
  
  .badge.bg-danger {
      color: black !important;
      border: 1px solid black !important;
      background-color: white !important; /* توفير حبر ملون */
      font-weight: bold;
      font-size: 12pt;
  }
  
  /* ترويسة الجدول */
  .table-dark {
      background-color: #000 !important;
      color: #fff !important;
      -webkit-print-color-adjust: exact;
  }
}
</style>